import React, { useState } from 'react';
import { useGame } from '../context/GameContext';
import './NavBar.css';

const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: '◈' },
  { id: 'lessons', label: 'Learn', icon: '⬡' },
  { id: 'achievements', label: 'Achievements', icon: '◆' },
  { id: 'leaderboard', label: 'Leaderboard', icon: '▲' },
];

export default function NavBar({ page, navigate }) {
  const { username, level, xp, xpProgress, xpForNextLevel } = useGame();
  const [menuOpen, setMenuOpen] = useState(false);
  const progress = Math.min(100, (xpProgress / xpForNextLevel) * 100);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <button className="navbar-brand" onClick={() => navigate('dashboard')}>
          <span className="brand-icon">&#9670;</span>
          <span className="brand-name">learn<span className="brand-accent">-ngk</span></span>
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className={`nav-link ${page === item.id ? 'active' : ''}`}
              onClick={() => { navigate(item.id); setMenuOpen(false); }}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </div>

        <div className="navbar-player">
          <div className="player-info">
            <div className="player-header">
              <span className="player-name">{username}</span>
              <span className="player-level">LVL {level}</span>
            </div>
            <div className="xp-bar-outer" style={{ width: 100 }}>
              <div className="xp-bar-inner" style={{ width: `${progress}%` }} />
            </div>
            <span className="xp-label">{xp} XP</span>
          </div>
          <div className="player-avatar">{username[0]?.toUpperCase()}</div>
        </div>

        <button className="hamburger" onClick={() => setMenuOpen(m => !m)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
